class FlipCard {
	constructor($timeout, $rootScope, $templateCache) {
		this.scope = {
			static: '=?'
		};

		this.restrict = 'E';
		this.link = this.flipCardLink;
		this.transclude = {
			front: 'front',
			back: '?back'
		};

		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.$templateCache = $templateCache;
		const template = this.$templateCache.get('flip-card/flip-card.html');
		this.template = template;
	}

	flipCardLink(scope, element, attrs) {
		const { href } = attrs;
		const $element = angular.element(element);
		const isStatic = Object.keys(attrs).includes('static');
		if (isStatic) {
			angular.element('.flip-card-inner', $element).addClass('static');
		}

		if (href && href.length > 3) {
			$element.on('click', (evt) => {
				this.handleNavigation(href, evt);
			});

			angular.element('*', $element).each((ele) => {
				const $ele = angular.element(ele);

				$ele.on('click', (evt) => {
					this.handleNavigation(href, evt);
				});
			});
		}
	}

	handleNavigation(page, event) {
		this.$timeout(() => {
			this.$rootScope.$broadcast('side-bar-changed-financial', false);

			if (page.includes('?')) {
				const fields = page.split('?');
				page = fields[0];
				const tempParams = fields[1].split('=');
				const stringParams = `{ 
					"${tempParams[0]}": "${tempParams[1]}"
				}`;

				const params = JSON.parse(stringParams);
				this.$rootScope.$broadcast('navigate-changed', page, params);
			} else {
				this.$rootScope.$broadcast('navigate-changed', page);
			}

			this.$rootScope.$broadcast('client-navigation-changed', { path: page });
		});
	}
}

export default /* @ngInject */ ($timeout, $rootScope, $templateCache) =>
	new FlipCard($timeout, $rootScope, $templateCache);
